/* unplugin-vue-components disabled */import script from "./SelectTimerRule.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectTimerRule.vue?vue&type=script&lang=ts&setup=true"

import "./SelectTimerRule.vue?vue&type=style&index=0&id=5987e914&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5987e914"]])

export default __exports__